import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);

export function initProductFeatures() {

    const sections = document.querySelectorAll(".section-product-features");
    if (!sections.length) return;

    sections.forEach(section => {

        const featured = section.querySelector(".featured-image-wrap");
        const items = section.querySelectorAll(".product-features .item");
        const images = section.querySelectorAll(".img-featured");

        if (!items.length) return;

        let currentImage = null;

        /* SECTION SCROLL ANIMATION */
        gsap.from(featured, {
            opacity: 0,
            y: 60,
            duration: 0.6,
            ease: "power3.out",
            scrollTrigger: {
                trigger: section,
                start: "25% center",
                end: "bottom top",
                anticipatePin: 1
            }
        });

        // function activateItem(item) {

        //     const targetId = item.getAttribute("attr-action-to");
        //     const targetImage = section.querySelector(`#${targetId}`);

        //     if (!targetImage || currentImage === targetImage) return;

        //     /* stop animation sebelumnya */
        //     gsap.killTweensOf(images);

        //     /* update active item */
        //     items.forEach(i => i.classList.remove("active"));
        //     item.classList.add("active");

        //     /* OUT animation */
        //     if (currentImage) {
        //         gsap.to(currentImage, {
        //             opacity: 0,
        //             y: 20,
        //             // scale: 0.98,
        //             duration: 0,
        //             ease: "power2.out",
        //             onComplete: () => {
        //                 currentImage.classList.remove("active");
        //             }
        //         });
        //     }

        //     /* IN animation */
        //     targetImage.classList.add("active");

        //     gsap.fromTo(
        //         targetImage,
        //         {
        //             opacity: 0,
        //             y: 20,
        //             scale: 1.3,
        //         },
        //         {
        //             opacity: 1,
        //             y: 0,
        //             // scale: 1.3,
        //             duration: 0,
        //             ease: "power3.out"
        //         }
        //     );

        //     currentImage = targetImage;
        // }

        function activateItem(item) {
            const targetId = item.getAttribute("attr-action-to");
            const targetImage = section.querySelector(`#${targetId}`);

            if (!targetImage || currentImage === targetImage) return;

            // stop animasi sebelumnya
            gsap.killTweensOf(images);

            // update active item
            items.forEach(i => i.classList.remove("active"));
            item.classList.add("active");

            // pastikan SEMUA image langsung hidden dulu
            // (biar nggak ada sisa opacity 1 dari state sebelumnya)
            gsap.set(images, { opacity: 0, y: 120, scale: 1.1});
            images.forEach(img => img.classList.remove("active"));

            // sekarang baru nyalakan target
            targetImage.classList.add("active");

            // IN animation (dari state yg sudah dipastikan 0)
            gsap.to(targetImage, {
                opacity: 1,
                y: 0,
                // scale: 1,
                duration: 0.6,          // silakan sesuaikan
                ease: "power3.out",
            });

            currentImage = targetImage;
        }

        /* CLICK EVENTS */
        items.forEach(item => {
            item.addEventListener("mouseenter", () => activateItem(item));
        });

        /* INIT FIRST ITEM */
        activateItem(items[0]);

    });

}